import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { styled } from 'styletron-react';
import { WizardStepsContainer } from '../../components/WizardSteps';
import { resetState } from '../../../frameworks_drivers/redux/reducers/onboardingInformation/onboardingInformationSlice';
import { TrackerUtil } from '../../../tracking/TrackerUtil';
import { pathOfFirstStepOfFlow } from '../../../frameworks_drivers/routes';
import useContact from '../../../tools/hooks/useContact';
import TitleWithPrevPageLink from '../../components/TitleWithPrevPageLink';

const Clickable = styled('span', {
  cursor: 'pointer'
});

const LinkToHome = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleOnClick = () => {
    dispatch(resetState());
    TrackerUtil.trackLinkClick(
      'offer-expired-create-new-offer-click',
      'offer_expired_create_new_offer_click'
    );
  };

  return (
    <Link className="link-to-home" to={pathOfFirstStepOfFlow} onClick={handleOnClick}>
      {t('pages.summary.linkToHomeDescription')}
    </Link>
  );
};

const OfferExpiredPage = () => {
  const { openCall, openEmail } = useContact('confirm-offer-expired');
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  useEffect(() => {
    const offerId = searchParams.get('offerId');

    TrackerUtil.trackEvent(
      'offer-expired',
      'page',
      'page_view',
      TrackerUtil.getPageName() + '_page_view',
      offerId || undefined
    );
  }, [searchParams]);

  return (
    <Container className={'pb-4 mb-5'}>
      <WizardStepsContainer />
      <TitleWithPrevPageLink title={t('pages.summary.titleExpired')} />
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <p className={'text-center'}>
            <Trans
              i18nKey="pages.summary.descriptionExpired"
              tOptions={{ skipPostProcessing: true }}
              components={[<LinkToHome />]}
            />
            <br />
            <br />
            <Trans i18nKey="ContactUsParagraph3" />
          </p>

          <p className="copy text-center fw-bold mb-0">
            Telefon:{' '}
            <Clickable onClick={openCall}>{t('headerPhoneSupportViewNumberToDisplay')}</Clickable>
            <br />
            E-Mail:{' '}
            <Clickable onClick={openEmail}>{t('pageCentralHeatingFallbackEMail')}</Clickable>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default OfferExpiredPage;
